














































import Vue from 'vue';
import TransferGraduationSendDocumentForm, {
  SendDocumentFormEvent,
} from '@/components/forms/TransferGraduationSendDocumentForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import { EvaluationTransferGraduation } from '@/store/modules/admission/state';
import { Toast, Loading } from '@descomplica/vue-components';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    TransferGraduationSendDocumentForm,
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    Toast,
    Loading,
  },
  data() {
    return {
      currentDocument: { ...this.$store.getters.transferGraduation?.document },
      isDocumentReadyForUpload: Boolean(this.$store.getters.transferGraduation?.document?.dataUrl),
      loading: false,
      error: false,
    };
  },
  computed: {
    admissionId(): number {
      return this.$store.getters.admissionId;
    },
    evaluationStatus(): string {
      return this.$store.getters.evaluationStatus;
    },
    name(): string {
      return this.$store.getters.user?.name || '';
    },
    transferGraduation(): EvaluationTransferGraduation {
      return this.$store.getters.transferGraduation;
    },
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch('PULL_EVALUATION_STATUS').catch(error => this.errorHandler(error));

    pipeline.next({ status: this.evaluationStatus });
    this.loading = false;
  },
  methods: {
    async deleteHandler() {
      this.isDocumentReadyForUpload = false;

      await this.$store.dispatch('DELETE_TRANSFER_GRADUATION_DOCUMENT');

      this.currentDocument = this.transferGraduation?.document;
    },
    async finishHandler() {
      this.loading = true;

      const transferGraduation: EvaluationTransferGraduation = {
        document: this.currentDocument,
      };

      if (this.currentDocument?.dataUrl) {
        await this.$store
          .dispatch('UPLOAD_TRANSFER_GRADUATION_DOCUMENT', {
            admissionId: this.admissionId,
            fileName: this.currentDocument.name,
            fileDataUrl: this.currentDocument.dataUrl,
          })
          .catch(error => this.errorHandler(error));
      }

      await this.$store
        .dispatch('UPDATE_TRANSFER_GRADUATION', { transferGraduation })
        .catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.ESSAY_EVALUATION_SENT);

      await this.$store.dispatch('PULL_EVALUATION_STATUS').catch(error => this.errorHandler(error));

      pipeline.next({ status: this.evaluationStatus });
      this.loading = false;
    },
    inputHandler({ fileName, fileDataUrl }: SendDocumentFormEvent) {
      if (fileDataUrl) {
        this.currentDocument.name = fileName;
        this.currentDocument.dataUrl = fileDataUrl;
        this.isDocumentReadyForUpload = true;
      }
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
